/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://gis.clark.wa.gov/portal/jsapi/jsapi4/esri/copyright.txt for details.
*/
import{empty as t}from"../../../geometry/support/aaBoundingRect.js";class e{constructor(e="scene"){this.context=e,this.extent=t()}}export{e as ElevationUpdateEvent};
